import React from "react";

const AdBanner = ({ data, type }) => {
  // We use the 'data' passed from the parent (App.js)
  if (!data?.banner_image) return null;  

  return (
    <div className={`Ad-banner-wrapper ${type}-banner`}>
      <a href={data.banner_link} target="_blank" rel="noreferrer">
        <img 
          src={data.banner_image} 
          alt={`${type} Promotion`} 
          className="mx-auto w-auto" 
        />
      </a>
    </div>
  );
};

export default AdBanner;